export const getCurrentDate = (separator='') => {
  let newDate = new Date()
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date}`
}

export const getDateFormat = (fdate='',separator='') => {
  let fDate = Date.parse(fdate)
  let date = fDate.getDate();
  let month = fDate.getMonth() + 1;
  let year = fDate.getFullYear();
  return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date}`
}